import { UserProfile } from "@src/types";
import { transformProfileTypeId } from "@src/utils";

const pendoInitialLabels = {
  initialAgency: "INITIAL_AGENCY",
  initialCompany: "INITIAL_COMPANY",
  initialOffice: "INITIAL_OFFICE",
  initialUserProfileId: "INITIAL_USER_PROFILE_ID",
  initialTenancyStatus: "INITIAL_TENANCY_STATUS"
};

export const pendoBlankLabels = {
  blankAgency: "BLANK_AGENCY",
  blankCompany: "BLANK_COMPANY",
  blankOffice: "BLANK_OFFICE",
  blankUserProfileId: "BLANK_USER_PROFILE_ID",
  blankTenancyStatus: "UNKNOWN"
};

export const pendoProfileTypeLabel = {
  owner: "owner",
  tenant: "tenant"
};

let currentPendoData = {
  visitor: {
    id: "",
    email: "",
    full_name: "",
    ownerOrTenant: "",
    agencyName: pendoInitialLabels.initialAgency,
    companyName: pendoInitialLabels.initialCompany,
    officeName: pendoInitialLabels.initialOffice,
    userProfileId: pendoInitialLabels.initialUserProfileId,
    tenancyStatus: pendoInitialLabels.initialTenancyStatus
  }
};

export const initPendoSessionWithEmailOnly = (emailAddress: string) => {
  if (!process.env.REACT_APP_Pendo_App_Id) return;

  if ((window as IntentionalAny<"Exists on window on Prod">).pendo) {
    currentPendoData = {
      visitor: {
        id: emailAddress,
        email: emailAddress,
        full_name: emailAddress,
        ownerOrTenant: "",
        agencyName: pendoInitialLabels.initialAgency,
        companyName: pendoInitialLabels.initialCompany,
        officeName: pendoInitialLabels.initialOffice,
        userProfileId: pendoInitialLabels.initialUserProfileId,
        tenancyStatus: pendoInitialLabels.initialTenancyStatus
      }
    };
    (window as IntentionalAny<"Exists on window on Prod">).pendo.initialize({
      apiKey: process.env.REACT_APP_Pendo_App_Id,
      visitor: currentPendoData.visitor
    });
  }
};

export const updatePendoWithNewDetails = (
  ownerOrTenant: string,
  userProfileId: string,
  companyName: string,
  agencyName: string,
  officeName: string,
  tenancyStatus?: string
) => {
  if (!process.env.REACT_APP_Pendo_App_Id) return;

  const pendo = (window as IntentionalAny<"Exists on window on Prod">).pendo;
  if (!pendo) return;

  const pendoVisitorData = currentPendoData.visitor;

  const isBasicDataSame =
    pendoVisitorData.ownerOrTenant === ownerOrTenant &&
    pendoVisitorData.userProfileId === userProfileId &&
    pendoVisitorData.companyName === companyName &&
    pendoVisitorData.agencyName === agencyName &&
    pendoVisitorData.officeName === officeName;

  const isTenancySame = !tenancyStatus || pendoVisitorData.tenancyStatus === tenancyStatus;
  if (isBasicDataSame && isTenancySame) return;

  pendoVisitorData.ownerOrTenant = ownerOrTenant;
  pendoVisitorData.userProfileId = userProfileId;
  pendoVisitorData.companyName = companyName;
  pendoVisitorData.agencyName = agencyName;
  pendoVisitorData.officeName = officeName;

  if (tenancyStatus) {
    pendoVisitorData.tenancyStatus = tenancyStatus;
  }

  pendo.updateOptions({ visitor: pendoVisitorData });
};

export const updatePendoWithOwnerTenantDetails = (ownerOrTenant: string) => {
  if (!process.env.REACT_APP_Pendo_App_Id) return;

  if ((window as IntentionalAny<"Exists on window on Prod">).pendo) {
    currentPendoData.visitor.ownerOrTenant = ownerOrTenant;
    (window as IntentionalAny<"Exists on window on Prod">).pendo.updateOptions(currentPendoData);
  }
};

export const updatePendoWithOfficeAgencyCompanyDetails = (companyName: string, agencyName: string, officeName: string) => {
  if (!process.env.REACT_APP_Pendo_App_Id) return;

  if ((window as IntentionalAny<"Exists on window on Prod">).pendo) {
    currentPendoData.visitor.companyName = companyName;
    currentPendoData.visitor.agencyName = agencyName;
    currentPendoData.visitor.officeName = officeName;
    (window as IntentionalAny<"Exists on window on Prod">).pendo.updateOptions(currentPendoData);
  }
};

export const setPendoAccountDetails = (account: IntentionalAny<"Not sure yet">) => {
  (window as IntentionalAny<"Exists on window on Prod">).identify({ account });
};
